import { REQUEST_STATUS } from "@src/constants";
import { RequestOverviewDetails } from "@src/types";

export function checkIsProposedRequestUpdated(
  request: RequestOverviewDetails
): boolean {
  return (
    (request?.status === REQUEST_STATUS.PROPOSED ||
      request?.status === REQUEST_STATUS.CONFIRMED) &&
    request?.childRequest?.status === REQUEST_STATUS.REQUESTED
  );
}

export function checkIsDeclinedRequestUpdated(
  request: RequestOverviewDetails
): boolean {
  return (
    request?.status === REQUEST_STATUS.DECLINED &&
    request?.childRequest?.status === REQUEST_STATUS.REQUESTED
  );
}
